export function usesAbiturientBearerAuth(role, authMethod) {
	return role === 'abiturient' && (authMethod === 'password' || authMethod === 'ecp');
}

export function usesCollegeBearerAuth(role, authMethod) {
	return role === 'college' && authMethod === 'ecp';
}

export function usesBearerAuth(role, authMethod) {
	return usesAbiturientBearerAuth(role, authMethod) || usesCollegeBearerAuth(role, authMethod);
}

export function usesAbiturientNewApi(role, authMethod) {
	return usesAbiturientBearerAuth(role, authMethod);
}

export function mapAbiturientUser(user) {
	if (!user) {
		return {};
	}
	return {
		...user,
		birthDate: user.birthday || user.birthDate || '',
	};
}

export function mapCollegeUser(user) {
	if (!user) {
		return {};
	}
	return {
		...user,
	};
}

export function extractLoginToken(response) {
	const data = response && response.data && response.data.data;
	return (data && data.token)
		|| (response && response.headers && response.headers.authorization)
		|| '';
}
